import { Box, Table, TableCell, TableRow } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import request from '../../utils/request';
import moment from 'moment';
import { CSSProperties } from 'react';

type RiskDescriptionProp = {
  rfqDetails: any;
  rfqId: any;
  setFieldsEmptyCheck?: any;
  placementSlipData?: any;
  type?: any;
  policyDetail?: any
};

const PlacementSlipRiskDescription: FC<RiskDescriptionProp> = ({
  rfqDetails,
  rfqId,
  setFieldsEmptyCheck,
  placementSlipData,
  type = null,
  policyDetail = null
}) => {
  const [riskDescriptionErr, setRiskDescriptionErr] = useState(false);
  const [value, setValue] = useState('');
  useEffect(() => {
    setValue(rfqDetails?.riskDescription);
  }, [rfqDetails?.riskDescription]);

  useEffect(() => {
    if (
      (value === '' || value === null) &&
      rfqDetails?.policyProduct?.riskdescription === true
    ) {
      if (setFieldsEmptyCheck) setFieldsEmptyCheck(false);
    }
  });

  const callSaveFunction = debounce((saveValue: string, event) => {
    saveCustomerDetails(saveValue);
  }, 2000);

  function debounce(callback, delay = 2000) {
    var time;
    return (...args) => {
      clearTimeout(time);
      time = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  }

  const saveCustomerDetails = (saveValue) => {
    if (
      (saveValue != '' || saveValue != null) &&
      rfqDetails?.policyProduct?.riskdescription === true
    ) {
      setFieldsEmptyCheck(true);
    } else if (
      (saveValue === '' || saveValue === null) &&
      rfqDetails?.policyProduct?.riskdescription === true
    ) {
      setFieldsEmptyCheck(false);
    } else {
      setFieldsEmptyCheck(true);
    }

    request({
      url: 'rfq/saveRiskDescription',
      method: 'post',
      data: {
        rfqId: rfqId,
        riskDescription: saveValue
      }
    }).then(
      (response: any) => { },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleBlur = (field, value) => {
    if (!rfqDetails?.policyProduct?.riskdescription) {
      return;
    }

    if (field === 'RiskDescription') {
      if (value === null || value === '') {
        setRiskDescriptionErr(true);
        setFieldsEmptyCheck(false);
      } else {
        setRiskDescriptionErr(false);
      }
    }
  };

  const qcCellStyle: CSSProperties = {

    width: '50%',
    maxWidth: '50%',
    overflowWrap: 'break-word',
    minWidth: 0,
    paddingBottom: '4px!important',
    paddingTop: '4px !important',
    paddingLeft: '16px !important'
  };

  const placementCellStyle: CSSProperties = {
    padding: 0,
    width: '36.3vw',
    paddingTop: '2px !important',
    paddingBottom: '2px !important',
    paddingLeft: '1vw'
  };
  const activeCellStyle = type === 'qc' ? qcCellStyle : placementCellStyle;

  //   const updateCustomerDetails = (feild, value) => {

  //     if (feild == 'RiskDescription') {
  //         setRiskDescription(value);

  //     }
  // }
  return (
    <>
      <Table>
        {rfqDetails?.riskDescription && (
          <>
            <TableRow>
              <TableCell
                className="heading"
                colSpan={2}
                sx={{
                  background: 'rgb(9 84 174)',
                  color: '#fff',
                  paddingTop: '2px',
                  paddingBottom: '2px',

                }}
              >
                {'Risk Details'}
              </TableCell>
            </TableRow>
            <TableRow style={{
              opacity:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.risk_description_details?.status === 'approve'
                  ? 0.5
                  : 1,
              pointerEvents:
                (
                  policyDetail?.parentqcData ||
                  policyDetail?.insurancePolicy?.qcData
                )?.risk_description_details?.status === 'approve'
                  ? 'none'
                  : 'auto',

            }}>
              <TableCell
                sx={activeCellStyle}
              >
                Risk Description
              </TableCell>
              <TableCell
                sx={{
                  paddingTop: '2px !important',
                  paddingBottom: '2px !important',
                  paddingLeft: '16px !important',
                }}
              >
                {rfqDetails?.riskDescription ?? 'N/A'}
              </TableCell>

            </TableRow>
          </>
        )}
        {type != 'qc' && <TableRow
          style={{
            opacity:
              (
                policyDetail?.parentqcData ||
                policyDetail?.insurancePolicy?.qcData
              )?.risk_description_details?.status === 'approve'
                ? 0.5
                : 1,
            pointerEvents:
              (
                policyDetail?.parentqcData ||
                policyDetail?.insurancePolicy?.qcData
              )?.risk_description_details?.status === 'approve'
                ? 'none'
                : 'auto',

          }}
        >
          <TableCell
            sx={activeCellStyle}
          >
            Policy Period
          </TableCell>
          <TableCell
            sx={{

              paddingTop: '2px!important',
              paddingBottom: '2px!important',
              paddingLeft: '16px!important'
            }}
          >
            <Box display="flex" gap="2vw">
              <span>
                From:{' '}
                {placementSlipData?.[0]?.policyStartDate
                  ? moment(placementSlipData[0].policyStartDate).format(
                    'DD-MM-YYYY'
                  )
                  : 'N/A'}
              </span>
              <span>
                To:{' '}
                {placementSlipData?.[0]?.policyEndDate
                  ? moment(placementSlipData[0].policyEndDate).format(
                    'DD-MM-YYYY'
                  )
                  : 'N/A'}
              </span>
            </Box>
          </TableCell>
        </TableRow>}

      </Table>
    </>
  );
};
export default PlacementSlipRiskDescription;
